/**
 * Generated by orval v8.21.0 🍺
 * Do not edit manually.
 * Kreditportal Backend API
 * Das Kreditportal ermöglicht Versicherungsnehmern die Kautionsverträge einzusehen, anzupassen und Bürgschaften zu beantragen. Diese API ist eine Middleware fürs Frontend zu den Backend-Systemen.
 * OpenAPI spec version: 4.0.6-FINAL
 */
import type { HttpContext, HttpEvent, HttpParams } from '@angular/common/http';
import { HttpClient, HttpHeaders, HttpResponse as AngularHttpResponse } from '@angular/common/http';

import { inject, Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import type {
    BeziehungenZuKundeResponse,
    MaklerRelationData,
    SteuerberaterRelationData
} from '../kreditportalBackendAPI.schemas';


interface HttpClientOptions {
  readonly headers?: HttpHeaders | Record<string, string | string[]>;
  readonly context?: HttpContext;
  readonly params?:
        | HttpParams
      | Record<string, string | number | boolean | Array<string | number | boolean>>;
  readonly reportProgress?: boolean;
  readonly withCredentials?: boolean;
  readonly credentials?: RequestCredentials;
  readonly keepalive?: boolean;
  readonly priority?: RequestPriority;
  readonly cache?: RequestCache;
  readonly mode?: RequestMode;
  readonly redirect?: RequestRedirect;
  readonly referrer?: string;
  readonly integrity?: string;
  readonly referrerPolicy?: ReferrerPolicy;
  readonly transferCache?: {includeHeaders?: string[]} | boolean;
  readonly timeout?: number;
}

type HttpClientBodyOptions = HttpClientOptions & {
  readonly observe?: 'body';
};

type HttpClientEventOptions = HttpClientOptions & {
  readonly observe: 'events';
};

type HttpClientResponseOptions = HttpClientOptions & {
  readonly observe: 'response';
};

type HttpClientObserveOptions = HttpClientOptions & {
  readonly observe?: 'body' | 'events' | 'response';
};







@Injectable({ providedIn: 'root' })
export class RelationApiService {
  private readonly http = inject(HttpClient);
/**
 * Dieser Service ermöglicht es, einen Steuerberater mit VSNR für den Zugriff zu einer VSNR zu verbinden.
 * @summary Zuordnung Relation zwischen Steuerberater und VSNR
 */
 anlegenSteuerberater<TData = void>(steuerberaterRelationData: SteuerberaterRelationData, options?: HttpClientBodyOptions): Observable<TData>;
 anlegenSteuerberater<TData = void>(steuerberaterRelationData: SteuerberaterRelationData, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 anlegenSteuerberater<TData = void>(steuerberaterRelationData: SteuerberaterRelationData, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  anlegenSteuerberater<TData = void>(
    steuerberaterRelationData: SteuerberaterRelationData, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.put<TData>(
      `/api/relation/steuerberater`,
      steuerberaterRelationData,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.put<TData>(
      `/api/relation/steuerberater`,
      steuerberaterRelationData,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.put<TData>(
      `/api/relation/steuerberater`,
      steuerberaterRelationData,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }
/**
 * Dieser Service ermöglicht es, eine bestehende Relation zwischen Steuerberater mit VSNR wieder aufzuheben.
 * @summary Löschung Relation zwischen Steuerberater und VSNR
 */
 loeschenSteuerberater<TData = void>(steuerberaterRelationData: SteuerberaterRelationData, options?: HttpClientBodyOptions): Observable<TData>;
 loeschenSteuerberater<TData = void>(steuerberaterRelationData: SteuerberaterRelationData, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 loeschenSteuerberater<TData = void>(steuerberaterRelationData: SteuerberaterRelationData, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  loeschenSteuerberater<TData = void>(
    steuerberaterRelationData: SteuerberaterRelationData, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.delete<TData>(
      `/api/relation/steuerberater`,{body: steuerberaterRelationData,...{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }}
    );
    }

    if (options?.observe === 'response') {
      return this.http.delete<TData>(
      `/api/relation/steuerberater`,{body: steuerberaterRelationData,...{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }}
    );
    }

    return this.http.delete<TData>(
      `/api/relation/steuerberater`,{body: steuerberaterRelationData,...{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }}
    );
  }
/**
 * Dieser Service ermöglicht es, einen Makler mit VSNR für den Zugriff zu einer VSNR zu verbinden.
 * @summary Zuordnung Relation zwischen Makler und VSNR
 */
 anlegenMakler<TData = void>(maklerRelationData: MaklerRelationData, options?: HttpClientBodyOptions): Observable<TData>;
 anlegenMakler<TData = void>(maklerRelationData: MaklerRelationData, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 anlegenMakler<TData = void>(maklerRelationData: MaklerRelationData, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  anlegenMakler<TData = void>(
    maklerRelationData: MaklerRelationData, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.put<TData>(
      `/api/relation/makler`,
      maklerRelationData,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.put<TData>(
      `/api/relation/makler`,
      maklerRelationData,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.put<TData>(
      `/api/relation/makler`,
      maklerRelationData,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }
/**
 * Dieser Service ermöglicht es, eine bestehende Relation zwischen Makler mit VSNR wieder aufzuheben.
 * @summary Löschung Relation zwischen Makler und VSNR
 */
 loeschenMakler<TData = void>(maklerRelationData: MaklerRelationData, options?: HttpClientBodyOptions): Observable<TData>;
 loeschenMakler<TData = void>(maklerRelationData: MaklerRelationData, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 loeschenMakler<TData = void>(maklerRelationData: MaklerRelationData, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  loeschenMakler<TData = void>(
    maklerRelationData: MaklerRelationData, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.delete<TData>(
      `/api/relation/makler`,{body: maklerRelationData,...{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }}
    );
    }

    if (options?.observe === 'response') {
      return this.http.delete<TData>(
      `/api/relation/makler`,{body: maklerRelationData,...{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }}
    );
    }

    return this.http.delete<TData>(
      `/api/relation/makler`,{body: maklerRelationData,...{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }}
    );
  }
/**
 * Dieser Service ermöglicht es anhand einer VSNR eine bestehende Relation mit einem Steuerberater bzw. einem Makler zu ermitteln.
 * @summary Ermittle Beziehung zwischen VSNR und Steuerberater bzw. Makler
 */
 getBeziehungenZuKunde<TData = BeziehungenZuKundeResponse>(vsnr: string, options?: HttpClientBodyOptions): Observable<TData>;
 getBeziehungenZuKunde<TData = BeziehungenZuKundeResponse>(vsnr: string, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 getBeziehungenZuKunde<TData = BeziehungenZuKundeResponse>(vsnr: string, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  getBeziehungenZuKunde<TData = BeziehungenZuKundeResponse>(
    vsnr: string, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `/api/relation/${vsnr}/beziehungenZuKunde`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `/api/relation/${vsnr}/beziehungenZuKunde`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.get<TData>(
      `/api/relation/${vsnr}/beziehungenZuKunde`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }
};

export type AnlegenSteuerberaterClientResult = NonNullable<void>
export type LoeschenSteuerberaterClientResult = NonNullable<void>
export type AnlegenMaklerClientResult = NonNullable<void>
export type LoeschenMaklerClientResult = NonNullable<void>
export type GetBeziehungenZuKundeClientResult = NonNullable<BeziehungenZuKundeResponse>
